/** Public preview URL — the token is the script's own id. */
export function buildPublicScriptShareUrl(scriptId: string, origin: string): string {
  return `${origin}/s/${scriptId}`;
}
